function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 241.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "das") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.33,20.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67,20.83c0,5.56-8.34,5.56-8.34,0s8.34-5.55,8.34,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,20.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.83,41.67H4.17c-5.56,0-5.56-8.34,0-8.34H245.83C251.39,33.33,251.39,41.67,245.83,41.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.83,200a4.17,4.17,0,0,1-4.16-4.17V12.5a4.17,4.17,0,0,0-4.17-4.17H12.5A4.17,4.17,0,0,0,8.33,12.5V195.83c0,5.56-8.33,5.56-8.33,0V12.5A12.5,12.5,0,0,1,12.5,0h225A12.5,12.5,0,0,1,250,12.5V195.83A4.17,4.17,0,0,1,245.83,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,220.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33,220.83c0,5.56-8.33,5.56-8.33,0s8.33-5.55,8.33,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,220.83a16.46,16.46,0,0,1,.61-4.16H20.83c-5.55,0-5.55,8.33,0,8.33h88.11A17.8,17.8,0,0,1,108.33,220.83Zm120.84-4.16H141.06a14.52,14.52,0,0,1,0,8.33h88.11C234.72,225,234.72,216.67,229.17,216.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,208.33a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,125,208.33Zm0,33.34a20.84,20.84,0,1,1,20.83-20.84A20.84,20.84,0,0,1,125,241.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,62.5a58.34,58.34,0,1,0,58.33,58.33A58.39,58.39,0,0,0,125,62.5Zm0,125a66.67,66.67,0,1,1,66.67-66.67A66.74,66.74,0,0,1,125,187.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,91.67a113.38,113.38,0,0,1-34.95-5.51c-5.29-1.74-2.69-9.64,2.61-8A104.91,104.91,0,0,0,167,76.26c5.16-2,8.21,5.73,3,7.76a111.51,111.51,0,0,1-40.8,7.65ZM81.51,169.36a4.16,4.16,0,0,1-1.82-7.9,113.08,113.08,0,0,1,91.84-3.17A4.17,4.17,0,1,1,168.4,166a104.92,104.92,0,0,0-85,3,4,4,0,0,1-1.87.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,63.54a70.8,70.8,0,0,0,0,114.54,70.8,70.8,0,0,0,0-114.54Zm0,123.78a4.2,4.2,0,0,1-2.3-.69,79.13,79.13,0,0,1,0-131.6,4.13,4.13,0,0,1,4.64,0,79.1,79.1,0,0,1,0,131.6,4,4,0,0,1-2.34.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,125.34H79.34c-5.55,0-5.55-8.33,0-8.33H184C189.58,117,189.58,125.34,184,125.34Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.6dff54bc1e44e7c023c9a7910943a83b.svg";
export { ForwardRef as ReactComponent };